<section>
    <header class="graph-date-controls">
        <p class="downloads-chart-header-wrapper">
            <span class="single-month-chart-header">Incident download triggered</span>
            <span [style.visibility]="isShowingCurrentMonth ? 'visible' : 'hidden'" class="current-month-label">(Current Month)</span>
        </p>
        <date-selector (selectedDateChange)="startDate = $event" [selectedDate]="startDate" [startDate]="earliestSelectionDate" [endDate]="latestSelectionDate"/>
    </header>
    <div class="download-cards">
        <count-card [icon]="'books_movies_and_music'" [label]="downloadAllCard?.label" [count]="downloadAllCard?.count"></count-card>
        <count-card [icon]="'slideshow'" [label]="downloadClipCard?.label" [count]="downloadClipCard?.count"></count-card>
        <count-card [icon]="'music_note_2'" [label]="downloadClipAudioCard?.label" [count]="downloadClipAudioCard?.count"></count-card>
    </div>
</section>
